import { useReactiveVar } from '@apollo/client';
import { translateTemplateText } from '@focuslee/shared-mini-app';
import { useMemo, useState } from 'react';

import { activeQuestCompletions } from '../../client/apollo';
import { ListCategory, ListGoal, ListQuest } from '../../client/types';
import { mapDifficultyToXp, timeValueToXP } from '../../helpers/experience';
import { AnimatedQuestItem } from '../animations/AnimatedQuestItem';
import { QuestItemCell } from './QuestItemCell';
import { QuestItemCompletedCell } from './QuestItemCompletedCell';
import { useTranslation } from 'react-i18next';

export type QuestItemProps = {
    quest: ListQuest;
    overdue: boolean;
    categoryMap: Record<string, ListCategory>;
    goalMap: Record<string, ListGoal>;
    onClick: () => void;
    dueDateVerbose?: boolean;
};

export const QuestItem = ({ quest, overdue, categoryMap, goalMap, onClick, dueDateVerbose = false }: QuestItemProps) => {
    const { t } = useTranslation();
    const activeCompletions = useReactiveVar(activeQuestCompletions);
    const matchingCompletion = activeCompletions.get(quest.id);
    const [pressed, setPressed] = useState(false);
    const category = categoryMap[quest.categoryId];
    const goal = quest.goalId && quest.goalId in goalMap ? goalMap[quest.goalId] : null;
    const goalCategory = goal && goal.categoryId in categoryMap ? categoryMap[goal.categoryId] : null;
    const questXP = useMemo(() => quest.timing && quest.timedInterval === 0 ? timeValueToXP(quest.timerValueInMs!) : mapDifficultyToXp(quest.difficulty), [quest.timing, quest.timerValueInMs, quest.difficulty]);
    
    return (
        <AnimatedQuestItem overdue={overdue} justCompleted={!!matchingCompletion} pressed={pressed}>
            {matchingCompletion ? (
                <QuestItemCompletedCell
                    completion={matchingCompletion}
                    questName={translateTemplateText(t, quest.templateId, 'name', quest.name)}
                />
            ) : (
                <QuestItemCell
                    quest={quest}
                    overdue={overdue}
                    category={category}
                    goal={goal}
                    goalCategory={goalCategory}
                    questXP={questXP}
                    onComplete={() => {}}
                    onClick={onClick}
                    onPressedChange={setPressed}
                    dueDateVerbose={dueDateVerbose}
                />
            )}
        </AnimatedQuestItem>
    );
}
